import React from "react";
import WeatherIcon from "./WeatherIcon";

export default function Daily(props) {
  function min() {
    let temp = Math.round(props.forecast.temp.min);
    return `${temp}°C`;
  }

  function max() {
    let temp = Math.round(props.forecast.temp.max);
    return `${temp}°C`;
  }

  function day() {
    let date = new Date(props.forecast.dt * 1000);
    let day = date.getDay();
    let days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    return days[day];
  }

  return (
    <div>
      <div className="col">
        <div>{day()}</div>
        <WeatherIcon icon={props.forecast.weather[0].icon} size="32" />
        <div>
          {min()} {max()}
        </div>
      </div>
    </div>
  );
}
